import React from 'react';
import { Bread } from './Bread';
import { Typography, useMediaQuery } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

type TProps = {
  items: any[];
  hideBreadcrumbIcon?: boolean;
};

const styles = makeStyles()(theme => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginTop: 10,
    },
    name: {
      color: '#181c32b3',
      fontSize: 16,
      fontWeight: theme.typography.fontWeightRegular,
      cursor: 'pointer',
      textWrap: 'nowrap',
    },
  };
});

const BreadCrumbs: React.FC<TProps> = ({ items, hideBreadcrumbIcon }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { classes } = styles();
  const isMobile = useMediaQuery('(max-width:1024px)');

  const isProductPage =
    location.pathname.includes('/products/catalog') ||
    location.pathname.includes('/viewproduct/');

  if (!items || !items.length || (isMobile && isProductPage)) {
    return <></>;
  }

  const lastCategory = items[items.length - 1];
  const childrens =
    lastCategory?.children?.find((i: any) => lastCategory.id === i.id)?.children || [];
  const length = items.length;
  return (
    <div className='kt-subheader__breadcrumbs'>
      {items.map((item, index) => (
        <Bread key={`bc${index}`} item={item} index={index} length={length} />
      ))}
      <span className='kt-subheader__breadcrumbs-separator' />
      <div className={classes.container}>
        {childrens.map((item: any, index: number) => (
          <React.Fragment key={index}>
            <Typography
              component='span'
              className={classes.name}
              sx={{ '&:hover': { color: '#205373' } }}
              onClick={() => {
                if (item.id && lastCategory?.onClickCategory) {
                  navigate(`/${lastCategory.page}`);
                  lastCategory.onClickCategory?.(item.id);
                }
              }}
            >
              {item.name}
              {index < childrens.length - 1 && <>&nbsp;|&nbsp;</>}
            </Typography>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default BreadCrumbs;
